import { TreeViewItem } from "projects/shared/lib/components/shared/tree-view/item/tree-view-item.model";
import { Observable } from "rxjs";
import { EProductCategoryImageType, ProductCategoryDetailGetQueryResult, ProductCategoryImageGetQueryResult } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";

export abstract class IProductCategoryService {

  abstract categoryTreeChangedGet(): Observable<TreeViewItem[] | undefined>;

  abstract productCategoryGetByCategoryKeyAsync(categoryKey: string | undefined): Promise<TreeViewItem | undefined>;

  abstract productCategoryListGetByCategoryKeyAsync(categoryKey: string | undefined): Promise<TreeViewItem[]>;

  abstract productCategoryDescriptionGetByCategoryKeyAsync(categoryKey: string | undefined): Promise<string | undefined>;

  abstract productCategoryFilteringTechGroupNumberGetByCategoryKeyAsync(categoryKey: string): Promise<string | undefined>;

  abstract productCategoryDetailGetAsync(categoryKey: string | undefined): Promise<ProductCategoryDetailGetQueryResult>;

  abstract productCategoryTreeInitAsync(): Promise<void>;

  abstract productCategoryImageGetAsync(
    categoryKeyList: string[],
    productCategoryImageType: EProductCategoryImageType,
    insertFallback: boolean,
    useCancellationLogic?: boolean | undefined
  ): Promise<ProductCategoryImageGetQueryResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IProductCategoryServiceToken = new InjectionToken<IProductCategoryService>('IProductCategoryServiceToken');
